var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedpdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H36L50 18V56C50 58.2 48.2 60 46 60H14C11.8 60 10 58.2 10 56V8C10 5.8 11.8 4 14 4Z",
    fill: "#E53935"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 4V18H50",
    fill: "#EF5350"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 42,
    textAnchor: "middle",
    fill: "white",
    fontSize: 14,
    fontWeight: 700,
    fontFamily: "Arial, Helvetica, sans-serif"
  }, "\r\n    PDF\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedpdf);
export default __webpack_public_path__ + "static/media/redpdf.fb0f2f403522dc1a0b0a1cc63b08acb8.svg";
export { ForwardRef as ReactComponent };